import mSEProject from "../projects/mSE-Project";
import ScrollingInfoProject from "../projects/scrollingInfo-Project";
import InfoExpProject from "../projects/infoExp-Project";
import MotionReelProject from "../projects/motionReel-Project";
import vs3Project from "../projects/vs3-Project";
import emailTemplatesProject from "../projects/emailTemplates-Project";
import TheCenterWordpress from "./theCenterWordpress-Project";
import rgbdleProject from "./rgbdle-Project";
import vibesEmailProject from "./vibesEmail-Project";
import decisionMakingToolProject from "./decisionMakingTool-Project";
import surveyRedesignProject from "./surveyRedesign-Project";

export const AllProjects = [
  InfoExpProject,
  rgbdleProject,
  emailTemplatesProject,
  vs3Project,
  ScrollingInfoProject,
  vibesEmailProject,
  mSEProject,
  MotionReelProject,
  TheCenterWordpress,
  decisionMakingToolProject,
  surveyRedesignProject,
];

export const AllProjectsMapped = {
  infoExp: InfoExpProject,
}


  